export const IS_STAGE_BUILD = process.env.BUILD_ENV === 'staging';
export const INTERCOM_APP_ID = process.env.NEXT_PUBLIC_INTERCOM_APP_ID || 'tcm3gu2e';
export const INTERCOM_IDENTITY_VERIFICATION_SECRET = process.env.INTERCOM_IDENTITY_VERIFICATION_SECRET || '';

export const BASE_HOST = process.env.NEXT_PUBLIC_BASE_HOST || 'http://localhost:3000';
export const API_HOST = process.env.NEXT_PUBLIC_API_HOST || BASE_HOST;
export const API_PATH = `${API_HOST}/api`;
export const IS_DEV = process.env.NEXT_PUBLIC_ENV === 'development';

export const IDP_HOST = process.env.NEXT_PUBLIC_IDP_HOST || 'https://id.hiveon.com';
export const OAUTH_HOST = process.env.NEXT_PUBLIC_OAUTH_HOST || 'https://hiveon.net';
export const LOGIN_LINK = process.env.NEXT_PUBLIC_LOGIN_LINK || `${IDP_HOST}/auth/realms/id/protocol/openid-connect/auth?client_id=account&response_type=code&scope=email`;
export const ACCOUNT_SETTINGS_LINK = `${IDP_HOST}/auth/realms/id/account`;
export const ACCOUNT_CHANGE_PASSWORD_LINK = `${IDP_HOST}/auth/realms/id/account/password`;
export const ACCOUNT_2FA_LINK = `${IDP_HOST}/auth/realms/id/account/totp`;
